import { type QueryHookOptions, useQuery } from "@apollo/client";
import { CurrentPlatformQuery } from "../graphql/queries";
import type { CurrentPlatformQueryType } from "@/types/graphql/partner.generated";

export const useCurrentPlatformQuery = (
  options?: QueryHookOptions<CurrentPlatformQueryType>
) => {
  return useQuery<CurrentPlatformQueryType>(CurrentPlatformQuery, options);
};
